import { FC } from "react";
import { IconButton, Stack, Toolbar, Typography } from "@mui/material";
import { useAtomValue } from "jotai";
import logo from "../../../../assets/logo.svg";
import { viewTitle } from "../../../../state/view";
import AppBarContainer from "./AppBarContainer";
import UserCompany from "./UserCompany";
import UserDisplayData from "./UserDisplayData";

interface Props {
	menuIsOpen: boolean;
	openMenu: () => void;
}

/**
 * AppBar renders the application top bar, which includes intra-section navigation features.
 *
 * @param menuIsOpen  indicates if the menu is open; this flag is used to correctly render
 *                    the application top bar according to side menu status
 * @param openMenu    the handler used to open the application side menu
 * @returns           the application top bar
 */
const AppBar: FC<Props> = ({ menuIsOpen, openMenu }) => {
	const title = useAtomValue(viewTitle);

	return (
		<AppBarContainer elevation={3} position="fixed" open={menuIsOpen}>
			<Toolbar className="app-bar" sx={{ justifyContent: menuIsOpen ? "flex-end" : "space-between" }}>
				{!menuIsOpen && (
					<>
						<IconButton edge="start" color="inherit" onClick={openMenu} aria-label="open menu">
							<img width={24} src={logo} alt="green-router-logo" />
						</IconButton>

						<Typography className="app-bar-title" variant="h6" flexGrow={1}>
							{title}
						</Typography>
					</>
				)}

				<Stack direction="row" spacing={1} alignItems="center">
					<UserCompany />
					<UserDisplayData />
				</Stack>
			</Toolbar>
		</AppBarContainer>
	);
};

export default AppBar;
